(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["quick-shop"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__quickShopInit) return;
    window.__quickShopInit = true;

    var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

    // Make the band's white match the actual page background exactly, rather
    // than the card's color-scheme background (which can read slightly grey).
    (function matchPageBackground() {
      function isTransparent(c) {
        return !c || c === 'transparent' || c === 'rgba(0, 0, 0, 0)';
      }
      function apply() {
        var c = getComputedStyle(document.body).backgroundColor;
        if (isTransparent(c)) c = getComputedStyle(document.documentElement).backgroundColor;
        if (!isTransparent(c)) {
          document.documentElement.style.setProperty('--quick-shop-bg', c);
        }
      }
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', apply);
      } else {
        apply();
      }
    })();

    function toast(msg) {
      var el = document.querySelector('.quick-shop-toast');
      if (!el) {
        el = document.createElement('div');
        el.className = 'quick-shop-toast';
        document.body.appendChild(el);
      }
      el.textContent = msg;
      requestAnimationFrame(function () { el.classList.add('is-visible'); });
      clearTimeout(el._t);
      el._t = setTimeout(function () { el.classList.remove('is-visible'); }, 2200);
    }

    function getCart() {
      return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    }

    document.addEventListener('click', async function (e) {
      // Find a size button under the pointer. Check the event target first,
      // then fall back to a geometric hit-test so this still works even when
      // the card's full-card product link is painted on top of the buttons.
      var btn = (e.target.closest && e.target.closest('.quick-shop__size')) || null;
      if (!btn && typeof document.elementsFromPoint === 'function') {
        var stack = document.elementsFromPoint(e.clientX, e.clientY);
        for (var i = 0; i < stack.length; i++) {
          if (stack[i].classList && stack[i].classList.contains('quick-shop__size')) {
            btn = stack[i];
            break;
          }
        }
      }
      if (!btn) return;

      // A size button was tapped — stop the card link from navigating.
      e.preventDefault();
      e.stopPropagation();

      if (btn.classList.contains('quick-shop__size--soldout') ||
          btn.getAttribute('aria-disabled') === 'true') return;

      var id = btn.dataset.variantId;
      if (!id || btn.classList.contains('is-loading')) return;

      btn.classList.add('is-loading');

      var cart = getCart();
      var body = { items: [{ id: Number(id), quantity: 1 }] };

      if (cart && typeof cart.getSectionsToRender === 'function') {
        try {
          body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
          body.sections_url = window.location.pathname;
        } catch (err) { /* ignore, will fall back */ }
      }

      try {
        var res = await fetch(ROOT + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
          body: JSON.stringify(body)
        });
        var data = await res.json();

        if (data.status) {
          throw new Error(data.description || data.message || 'No se pudo agregar');
        }

        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        setTimeout(function () { btn.classList.remove('is-added'); }, 1200);

        if (cart && typeof cart.renderContents === 'function') {
          cart.renderContents(data);
          if (cart.tagName.toLowerCase() === 'cart-drawer' && typeof cart.open === 'function') {
            cart.open();
          }
        } else {
          toast('Agregado a la bolsa');
          try {
            var b = await fetch(ROOT + '?sections=cart-icon-bubble');
            if (b.ok) {
              var j = await b.json();
              var frag = new DOMParser().parseFromString(j['cart-icon-bubble'] || '', 'text/html');
              var fresh = frag.querySelector('#cart-icon-bubble');
              var bubble = document.getElementById('cart-icon-bubble');
              if (bubble && fresh) bubble.innerHTML = fresh.innerHTML;
            }
          } catch (err2) { /* non-fatal */ }
        }

        document.dispatchEvent(new CustomEvent('quick-shop:added', { detail: { variantId: id } }));
      } catch (err) {
        btn.classList.remove('is-loading');
        toast(err.message || 'Error');
      }
    }, true);

    // Hover state — driven manually because Horizon's full-card link overlay
    // sits above the buttons, so native :hover never reaches them.
    var hovered = null;
    function clearHover() {
      if (hovered) { hovered.classList.remove('is-hover'); hovered = null; }
    }
    document.addEventListener('pointermove', function (e) {
      if (e.pointerType && e.pointerType !== 'mouse') return; // touch has no hover
      if (!e.target || !e.target.closest || !e.target.closest('.card-wrapper')) {
        clearHover();
        return;
      }
      var found = null;
      var stack = document.elementsFromPoint(e.clientX, e.clientY);
      for (var i = 0; i < stack.length; i++) {
        if (stack[i].classList && stack[i].classList.contains('quick-shop__size')) {
          found = stack[i];
          break;
        }
      }
      if (found && (found.classList.contains('quick-shop__size--soldout') ||
          found.getAttribute('aria-disabled') === 'true')) {
        found = null;
      }
      if (found === hovered) return;
      clearHover();
      if (found) { found.classList.add('is-hover'); hovered = found; }
    });
    document.addEventListener('pointerleave', clearHover, true);
  })();
  } catch(e) { console.error(e); }
})();

})();
